export default __webpack_public_path__ + "static/media/ocean.bc667795.png";